<section class="faq" id="faq">
  <h2>Have more questions? Check it out here</h2>

  <div class="faq-list">
    @for (item of items; track item.question; let i = $index) {
      <div class="faq-item" [class.open]="openIndex() === i">
        <button
          type="button"
          class="faq-question"
          [attr.aria-expanded]="openIndex() === i"
          (click)="toggle(i)"
        >
          <span>{{ item.question }}</span>
          <span class="faq-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
          </span>
        </button>

        @if (openIndex() === i) {
          <div class="faq-answer">
            <p>{{ item.answer }}</p>
          </div>
        }
      </div>
    }
  </div>
</section>
